module.exports = __webpack_public_path__ + "img/35_36.ffdbc431.png";